// type ICheckpoints = (Record<string | number, unknown> & { locationId: string })[];
import { CheckpointOperationType } from '../enums';

interface HasLocationId {
    locationId: string;
    isStopover?: boolean;
    operationType?: CheckpointOperationType;
}

const isStopoverCheckpoint = (checkpoint?: HasLocationId): boolean =>
    !!checkpoint && (checkpoint.isStopover === true || checkpoint.operationType === CheckpointOperationType.STOPOVER);

/**
 * The duplicate-location restriction applies only to carga/descarga. A stopover may share its
 * location with an adjacent stop — that is how a desenganche at a plant or border gets its own
 * computed times — and two consecutive stopovers may share one too (frontera con doble control).
 * Only two adjacent carga/descarga stops on the same location remain invalid.
 */
const isContiguousPairValid = (current: HasLocationId, sibling?: HasLocationId): boolean => {
    if (sibling === undefined) return true;
    if (current.locationId !== sibling.locationId) return true;

    return isStopoverCheckpoint(current) || isStopoverCheckpoint(sibling);
};

export const areCpLocationsNonContiguous = <T extends HasLocationId[]>(
    checkpoints: T,
    currentCpIndex: number,
): boolean => {
    const current = checkpoints[currentCpIndex];

    return (
        isContiguousPairValid(current, checkpoints[currentCpIndex - 1]) &&
        isContiguousPairValid(current, checkpoints[currentCpIndex + 1])
    );
};
